import { render } from "./RadioButtonInput.vue?vue&type=template&id=4dfa7768&scoped=true"
import script from "./RadioButtonInput.vue?vue&type=script&lang=js"
export * from "./RadioButtonInput.vue?vue&type=script&lang=js"

import "./RadioButtonInput.vue?vue&type=style&index=0&id=4dfa7768&scoped=true&lang=scss"

import exportComponent from "/Users/Ralph/repos/verduurzamen/quickcheck/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dfa7768"]])

export default __exports__